export default __webpack_public_path__ + "static/media/772.9e460549.gif";